<div
    class="widget"
    cdkDrag
    appBaseWidget
    #bw="baseWidget"
    [fillRemaining]="fillRemaining()"
    [fixedSize]="fixedSize()"
    [widgetId]="widgetId()"
    [defaultHeight]="defaultHeight()"
    [defaultFraction]="defaultFraction()"
    [class.collapsed]="bw.isCollapsed()"
>
    <div class="widget-header" cdkDragHandle (dblclick)="bw.onHeaderDblClick()">
        <span class="widget-title">{{ widgetTitle() }}</span>
        <div class="widget-actions"></div>
    </div>

    <ng-template cdkDragPlaceholder>
        <div
            class="widget widget-placeholder"
            [style.height.px]="bw.defaultHeightPx()"
        >
            <i class="fa-solid fa-plus" aria-hidden="true"></i>
        </div>
    </ng-template>

    @if (!bw.isCollapsed()) {
        <div class="widget-content">
            @if (!isLoaded()) {
                <!-- loading -->
            } @else if (!hasData()) {
                <span class="no-data">{{ 'No data' | translate }}</span>
            } @else {
                <div class="chart">
                    @for (cat of categories()!; track cat.color) {
                        @if (cat.zone !== 'hidden') {
                            <div
                                class="col"
                                [style.width.%]="cat.pct"
                                (mouseenter)="onBarEnter(cat, $event)"
                                (mousemove)="onBarMove($event)"
                                (mouseleave)="onBarLeave()"
                            >
                                <div class="col-above">
                                    @if (cat.zone === 'above') {
                                        <div
                                            class="bar"
                                            [class]="cat.cssClass"
                                        ></div>
                                    }
                                </div>
                                <div class="col-line"></div>
                                <div class="col-below">
                                    @if (cat.zone === 'below') {
                                        <div
                                            class="bar"
                                            [class]="cat.cssClass"
                                        ></div>
                                    }
                                </div>
                            </div>
                        }
                    }
                </div>
                @if (tooltipVisible()) {
                    <div
                        class="tooltip"
                        [style.left.px]="tooltipX()"
                        [style.top.px]="tooltipY()"
                    >
                        {{ tooltipText() }}
                    </div>
                }
            }
        </div>
    }
    <div class="resize-handle" (mousedown)="bw.onDragStart($event)"></div>
</div>
